module.exports = __webpack_public_path__ + "static/img/nodeNum.c909c4d1.png";